
<div #ordersTable>
  @if (loading) {
    <div class="loading">
      <ds-progress-spinner progress_mode="indeterminate"></ds-progress-spinner>
    </div>
  }

  <!-- desktop template -->
  <div *appIsDesktop>
    @if (!loading && !noResults) {
      <div id="ln-open-orders-table-container">
        <ds-table mat-table [dataSource]="lnOrders" [displayedColumns]="isShipped ? displayedColumnsShipped : displayedColumns">
          <ng-container matColumnDef="customerName">
            <th mat-header-cell *matHeaderCellDef> {{ appStrings.label_customerName }} </th>
            <td mat-cell *matCellDef="let order;let i = dataIndex" [id]="'customerName_'+i" > {{ order.accountName }} </td>
          </ng-container>
          <ng-container matColumnDef="bpNumber">
            <th mat-header-cell *matHeaderCellDef> {{ appStrings.quoteSearch_bpNumber }} </th>
            <td mat-cell *matCellDef="let order;let i = dataIndex" [id]="'bpNumber_'+i"> {{ order.bpNumber }} </td>
          </ng-container>
          <ng-container matColumnDef="lnOrderNumber">
            <th mat-header-cell *matHeaderCellDef> {{ appStrings.ln_orderNumber }} </th>
            <td mat-cell *matCellDef="let order;let i = dataIndex" [id]="'lnOrderNumber_'+i"> {{ order.orderNumber }} </td>
          </ng-container>
          <ng-container matColumnDef="orderDate">
            <th mat-header-cell *matHeaderCellDef> {{ appStrings.orderDetails__orderDate }} </th>
            <td mat-cell *matCellDef="let order;let i = dataIndex" [id]="'orderDate_'+i"> {{ order.orderDate | date: dateFormat }} </td>
          </ng-container>
          <ng-container matColumnDef="shipDate">
            <th mat-header-cell *matHeaderCellDef> {{ appStrings.lastTen_shipDate }} </th>
            <td mat-cell *matCellDef="let order;let i = dataIndex" [id]="'shipDate_'+i"> {{ order.orderDate | date: dateFormat }} </td>
          </ng-container>
          <ng-container matColumnDef="amount">
            <th mat-header-cell *matHeaderCellDef> {{ appStrings.quoteSearch_amount }} </th>
            <td mat-cell *matCellDef="let order;let i = dataIndex" [id]="'amount_'+i"> {{ order.total | currency: order.currencySign }} </td>
          </ng-container>
          <ng-container matColumnDef="poNumber">
            <th mat-header-cell *matHeaderCellDef> {{ appStrings.quoteSearch_poNumber }} </th>
            <td mat-cell *matCellDef="let order;let i = dataIndex" [id]="'poNumber_'+i"> {{ order.poNumber }} </td>
          </ng-container>
          <ng-container matColumnDef="trackingNumber">
            <th mat-header-cell *matHeaderCellDef> {{ appStrings.quoteSearch_trackingNumber }} </th>
            <td mat-cell *matCellDef="let order;let i = dataIndex" [id]="'trackingNumber'+i">
              @if (order.trackingNumbers?.length > 1) {
                <ds-button class="link" size="medium" type="tertiary" variant="label-only" [label]="appStrings.tracking_viewAll"
                  (onClick)="displayTrackingDialog(order.trackingNumbers, order.orderNumber)">
                </ds-button>
              }
              <!-- One Tracking Number -->
              @if (order.trackingNumbers?.length === 1 && order.trackingNumbers[0].trackingNumber) {
                <span>
                  {{ order.trackingNumbers[0].trackingNumber }}
                </span>
              }
              <!-- No Tracking Numbers -->
              @if (!order.trackingNumbers.length || (order.trackingNumbers?.length === 1 && !order.trackingNumbers[0].trackingNumber)) {
                <span
                  >
                  —
                </span>
              }
            </td>
          </ng-container>
          <ng-container matColumnDef="view">
            <th mat-header-cell *matHeaderCellDef></th>
            <td class="edit-order" mat-cell *matCellDef="let order;let i = dataIndex" [id]="'view_'+i">
              <ds-button class="view-quote-buton" size="medium" type="tertiary" variant="label-icon" icon="visibility" [label]="appStrings.button_view"
                (onClick)="goToOrderDetails(order)" iconStyle="material-icons-outlined" iconPosition="left">
              </ds-button>
            </td>
          </ng-container>
        </ds-table>
      </div>
    }
  </div>

  <!-- mobile template -->
  <div *appIsMobile class="mobile">
    @if (!loading && !noResults) {
      <div id="ln-open-orders-table-container">
        @for (order of lnOrders; track order; let i = $index) {
          <mat-expansion-panel class="mobile-card two-columns grey blue-border tall" [expanded]="false">
            <mat-expansion-panel-header>
              <mat-panel-title id="order-card-header-container" class="card-header-container">
                <span class="card-header">
                  <span id="order-card-title" class="title">
                    {{ order.accountName }}
                  </span>
                  <span id="order-card-subtitle" class="subtitle">
                    {{ order.bpNumber }}
                  </span>
                </span>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <ds-divider></ds-divider>
            <div class="content">
              <div class="row">
                <div class="column">
                  <typography [id]="'lnOrderNumber_label_'+i" class="label" variant="caption-2" weight="regular"> {{ appStrings.ln_orderNumber }} </typography>
                  <typography [id]="'lnOrderNumber_'+i" variant="body-2" weight="medium"> {{ order.orderNumber }} </typography>
                </div>
                <div class="column">
                  <typography [id]="'orderDate_label_'+i" class="label" variant="caption-2" weight="regular"> {{ appStrings.orderDetails__orderDate }} </typography>
                  <typography [id]="'orderDate_'+i" variant="body-2" weight="medium"> {{ order.orderDate | date: dateFormat }} </typography>
                </div>
              </div>
              <div class="row">
                <div class="column">
                  <typography [id]="'amount_label_'+i" class="label" variant="caption-2" weight="regular"> {{ appStrings.quoteSearch_amount }} </typography>
                  <typography [id]="'amount_'+i" class="project-types" variant="body-2" weight="medium"> {{ order.total | currency: order.currencySign }}</typography>
                </div>
                <div class="column">
                  <typography [id]="'poNumber_label_'+i" class="label" variant="caption-2" weight="regular"> {{ appStrings.quoteSearch_poNumber }} </typography>
                  <typography [id]="'poNumber_'+i" variant="body-2" weight="medium"> {{ order.poNumber }} </typography>
                </div>
              </div>
              <div class="row">
                <div class="column">
                  <typography [id]="'trackingNumber_label_'+i" class="label" variant="caption-2" weight="regular"> {{ appStrings.quoteSearch_trackingNumber }} </typography>
                  @if (order.trackingNumbers?.length > 1) {
                    <ds-button class="link" size="medium" type="tertiary" variant="label-only" [label]="appStrings.tracking_viewAll"
                      (onClick)="displayTrackingDialog(order.trackingNumbers, order.orderNumber)">
                    </ds-button>
                  }
                  <!-- One Tracking Number -->
                  @if (order.trackingNumbers?.length === 1 && order.trackingNumbers[0].trackingNumber) {
                    <typography variant="body-2" weight="medium">
                      {{ order.trackingNumbers[0].trackingNumber }}
                    </typography>
                  }
                  <!-- No Tracking Numbers -->
                  @if (!order.trackingNumbers.length || (order.trackingNumbers?.length === 1 && !order.trackingNumbers[0].trackingNumber)) {
                    <typography variant="body-2" weight="medium">
                      —
                    </typography>
                  }
                </div>
              </div>
            </div>
          </mat-expansion-panel>
        }
      </div>
    }
  </div>

  @if (noResults) {
    <div id="noResults" class="no-results">
      <typography variant="mat-subtitle-1" weight="regular">
        {{ appStrings.leads_noResults }}
      </typography>
    </div>
  }
</div>